"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var apollo_client_1 = require("apollo-client");
var apollo_link_1 = require("apollo-link");
var apollo_link_batch_http_1 = require("apollo-link-batch-http");
var apollo_link_retry_1 = require("apollo-link-retry");
var apollo_cache_inmemory_1 = require("apollo-cache-inmemory");
var apollo_utilities_1 = require("apollo-utilities");
var lodash_1 = require("lodash");
var apollo_link_error_1 = require("apollo-link-error");
var rql_1 = require("../schemas/rql");
var apollo_client_2 = require("@reverbdotcom/commons/dist/apollo_client");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
var local_apollo_schema_1 = require("./local_apollo_schema");
var inMemoryCache = new apollo_cache_inmemory_1.InMemoryCache(apollo_client_2.cacheOptions);
if (window.__APOLLO_STATE__) {
    inMemoryCache.restore(window.__APOLLO_STATE__);
}
var NON_REPORTABLE_ERRORS = ['CLIENT_ERROR', 'NOT_FOUND_ERROR'];
function buildClient(user, token) {
    return new apollo_client_1.default({
        typeDefs: local_apollo_schema_1.typeDefs,
        resolvers: local_apollo_schema_1.resolvers,
        cache: inMemoryCache,
        link: apollo_link_1.ApolloLink.from([
            apollo_link_error_1.onError(function (_a) {
                var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, operation = _a.operation;
                if (networkError) {
                    tracker_1.trackError({
                        name: "Apollo Network Error - " + operation.operationName,
                        context: {
                            message: networkError.message,
                            operation: operation.operationName,
                        },
                        ravenOptions: {
                            tags: { operation: operation.operationName },
                            fingerprint: ["Apollo Network Error - " + operation.operationName, networkError.message],
                        },
                    });
                }
                // Don't report client errors to Sentry
                var errors = graphQLErrors.filter(function (_a) {
                    var extensions = _a.extensions;
                    if (extensions) {
                        return !NON_REPORTABLE_ERRORS.includes(extensions.code);
                    }
                });
                if (errors.length) {
                    var errorName = "GraphQL Error - " + operation.operationName;
                    tracker_1.trackError({
                        name: errorName,
                        context: {
                            operation: operation.operationName,
                            graphQLErrors: graphQLErrors && graphQLErrors.map(function (_a) {
                                var message = _a.message, path = _a.path, extensions = _a.extensions;
                                return ({
                                    message: message,
                                    extensions: extensions,
                                    path: lodash_1.join(path || [], '.'),
                                });
                            }),
                        },
                        ravenOptions: {
                            tags: { operation: operation.operationName },
                            fingerprint: [errorName],
                        },
                    });
                }
            }),
            new apollo_link_retry_1.RetryLink({
                delay: {
                    initial: 300,
                    max: 10000,
                    jitter: true,
                },
                attempts: {
                    max: 3,
                    retryIf: function (error, graphqlOperation) {
                        // This will ONLY get triggered on a network error, not a GraphQL error
                        var operation = apollo_utilities_1.getMainDefinition(graphqlOperation.query).operation;
                        return !!error && operation === 'query';
                    },
                },
            }),
            new apollo_link_batch_http_1.BatchHttpLink({
                batchMax: 3,
                uri: RQL_HOST,
                headers: lodash_1.pickBy({
                    authorization: token,
                    'X-Item-Region': user.itemRegionOverride,
                    'X-Display-Currency': user.currency,
                    'X-Shipping-Region': user.shippingRegionCode,
                    'Accept-Language': user.locale,
                    'X-Context-Id': user.cookieId,
                    'X-Session-Id': user.sessionId,
                    'X-Reverb-App': rql_1.core_apimessages_Channel.REVERB,
                }),
            }),
        ]),
    });
}
exports.buildClient = buildClient;
//# sourceMappingURL=apollo_client.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/lib/apollo_client.js
// module id = 8ONN
// module chunks = 20 21